import { Either, Left, Right } from 'fp-ts/lib/Either'

import { log } from '@/log'
import { ApiClient } from '@/services/api/client'
import { ApiService } from '@/services/api/service'

const namespace = 'recommend-items'

/**
 * おすすめ商品APIサービス
 */
export default class RecommendItemsService extends ApiService {
  /**
   * 商品詳細画面用のおすすめ商品を取得
   *
   * FIXME: ApiProductclass[]を返却したい
   * Serviceとしてはany[]ではなくApiProductclass[]を返却するほうが本来親切である
   * しかし、既存のコンポーネント、特にItemList.vueとslotで注入されるItemWithLink.vueがApiProductclassと互換がないため
   * ひとまず既存実装と合わせる形でany[]を返却するようにしている
   *
   * @param fkuId 商品のFKU ID
   * @param brandEnglishName ブランド名
   * @returns Promise<Either<Error, any[]>>
   */
  async getRecommendItemsForDetail(
    fkuId: string,
    brandEnglishName: string
  ): Promise<Either<Error, any[]>> {
    try {
      const response = await ApiClient
        .get(`/api/common/${brandEnglishName}/item/fku/recommend_list/${fkuId}`)

      if (!response.body || !response.body.data || !Array.isArray(response.body.data)) {
        throw new Error('Invalid response: body or body.data is missing, or body.data is not an array')
      }

      log.debug({
        service: `${namespace}/getRecommendItemsForDetail`,
        response,
      })

      return new Right(response.body.data)
    } catch (error) {
      log.error({
        service: `${namespace}/getRecommendItemsForDetail`,
        error,
        fkuId,
        brandEnglishName,
      })

      return new Left(error)
    }
  }
}
